import { render, staticRenderFns } from "./FollowUpList.vue?vue&type=template&id=6278b37e&scoped=true"
import script from "./FollowUpList.vue?vue&type=script&lang=js"
export * from "./FollowUpList.vue?vue&type=script&lang=js"
import style0 from "./FollowUpList.vue?vue&type=style&index=0&id=6278b37e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6278b37e",
  null
  
)

export default component.exports